module.exports = __webpack_public_path__ + "img/PPMPRA7.d8103463.png";